export enum UserNotificationStatusEnum {
    ACTIVE                               = 1,
    PROCESSED                            = 2, // send, saved

}
